var map = {
	"./aurora04-1.jpg": 6305,
	"./c-c-desayunos-092.jpg": 3968,
	"./c-c-desayunos-094.jpg": 9366,
	"./c-c-desayunos-097.jpg": 1505,
	"./c-c-desayunos-098.jpg": 2397,
	"./c-c-desayunos-099.jpg": 6711,
	"./c-c-desayunos-100.jpg": 9836,
	"./c-c-desayunos-102.jpg": 1070,
	"./c-c-desayunos-103.jpg": 7531,
	"./c-c-desayunos-106.jpg": 4618,
	"./c-c-desayunos-107.jpg": 3623,
	"./c-c-desayunos-109.jpg": 497,
	"./c-c-desayunos-122.jpg": 3796,
	"./c-c-desayunos-125.jpg": 175,
	"./carlos-04-988x658.jpg": 1289,
	"./carlos-05-988x658.jpg": 9412,
	"./carlos-07-988x658.jpg": 4014,
	"./carlos-081-988x658.jpg": 2266,
	"./carlos-13-1.jpg": 2264,
	"./carlos-14-988x658.jpg": 5434,
	"./carlos-16-988x658.jpg": 4480,
	"./carlos-19-988x658.jpg": 8507,
	"./carlos-20-988x658.jpg": 8407,
	"./carlos-21-988x658.jpg": 9234,
	"./carlos-21ab-988x658.jpg": 3379,
	"./carlos-21abc-988x658.jpg": 1654,
	"./carlos-22-988x658.jpg": 9277,
	"./carlos-23-988x658.jpg": 2904,
	"./carlos-24-988x658.jpg": 3259,
	"./carlos-25-988x658.jpg": 6502,
	"./chicago04.jpg": 4187,
	"./cyc-123.jpg": 7763,
	"./cyc-135.jpg": 6370,
	"./cyc-165.jpg": 1257,
	"./cyc-181.jpg": 1283,
	"./cyc-26.jpg": 3939,
	"./cyc-37.jpg": 8365,
	"./cyc-41.jpg": 9717,
	"./cyc-6.jpg": 7821,
	"./cyc-61.jpg": 8596,
	"./cyc-71.jpg": 423,
	"./cyc-97.jpg": 6959,
	"./espanol_menu_antigua_01-04-2023_contraportada.jpg": 7229,
	"./slider5.jpg": 4231,
	"./slider7 (1).jpg": 2843,
	"./slider_logo_antigua.jpg": 5688,
	"./slider_platonuevo.jpg": 3574,
	"assets/images/restaurant/antigua/aurora04-1.jpg": 6305,
	"assets/images/restaurant/antigua/c-c-desayunos-092.jpg": 3968,
	"assets/images/restaurant/antigua/c-c-desayunos-094.jpg": 9366,
	"assets/images/restaurant/antigua/c-c-desayunos-097.jpg": 1505,
	"assets/images/restaurant/antigua/c-c-desayunos-098.jpg": 2397,
	"assets/images/restaurant/antigua/c-c-desayunos-099.jpg": 6711,
	"assets/images/restaurant/antigua/c-c-desayunos-100.jpg": 9836,
	"assets/images/restaurant/antigua/c-c-desayunos-102.jpg": 1070,
	"assets/images/restaurant/antigua/c-c-desayunos-103.jpg": 7531,
	"assets/images/restaurant/antigua/c-c-desayunos-106.jpg": 4618,
	"assets/images/restaurant/antigua/c-c-desayunos-107.jpg": 3623,
	"assets/images/restaurant/antigua/c-c-desayunos-109.jpg": 497,
	"assets/images/restaurant/antigua/c-c-desayunos-122.jpg": 3796,
	"assets/images/restaurant/antigua/c-c-desayunos-125.jpg": 175,
	"assets/images/restaurant/antigua/carlos-04-988x658.jpg": 1289,
	"assets/images/restaurant/antigua/carlos-05-988x658.jpg": 9412,
	"assets/images/restaurant/antigua/carlos-07-988x658.jpg": 4014,
	"assets/images/restaurant/antigua/carlos-081-988x658.jpg": 2266,
	"assets/images/restaurant/antigua/carlos-13-1.jpg": 2264,
	"assets/images/restaurant/antigua/carlos-14-988x658.jpg": 5434,
	"assets/images/restaurant/antigua/carlos-16-988x658.jpg": 4480,
	"assets/images/restaurant/antigua/carlos-19-988x658.jpg": 8507,
	"assets/images/restaurant/antigua/carlos-20-988x658.jpg": 8407,
	"assets/images/restaurant/antigua/carlos-21-988x658.jpg": 9234,
	"assets/images/restaurant/antigua/carlos-21ab-988x658.jpg": 3379,
	"assets/images/restaurant/antigua/carlos-21abc-988x658.jpg": 1654,
	"assets/images/restaurant/antigua/carlos-22-988x658.jpg": 9277,
	"assets/images/restaurant/antigua/carlos-23-988x658.jpg": 2904,
	"assets/images/restaurant/antigua/carlos-24-988x658.jpg": 3259,
	"assets/images/restaurant/antigua/carlos-25-988x658.jpg": 6502,
	"assets/images/restaurant/antigua/chicago04.jpg": 4187,
	"assets/images/restaurant/antigua/cyc-123.jpg": 7763,
	"assets/images/restaurant/antigua/cyc-135.jpg": 6370,
	"assets/images/restaurant/antigua/cyc-165.jpg": 1257,
	"assets/images/restaurant/antigua/cyc-181.jpg": 1283,
	"assets/images/restaurant/antigua/cyc-26.jpg": 3939,
	"assets/images/restaurant/antigua/cyc-37.jpg": 8365,
	"assets/images/restaurant/antigua/cyc-41.jpg": 9717,
	"assets/images/restaurant/antigua/cyc-6.jpg": 7821,
	"assets/images/restaurant/antigua/cyc-61.jpg": 8596,
	"assets/images/restaurant/antigua/cyc-71.jpg": 423,
	"assets/images/restaurant/antigua/cyc-97.jpg": 6959,
	"assets/images/restaurant/antigua/espanol_menu_antigua_01-04-2023_contraportada.jpg": 7229,
	"assets/images/restaurant/antigua/slider5.jpg": 4231,
	"assets/images/restaurant/antigua/slider7 (1).jpg": 2843,
	"assets/images/restaurant/antigua/slider_logo_antigua.jpg": 5688,
	"assets/images/restaurant/antigua/slider_platonuevo.jpg": 3574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1508;